import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface AnnouncementItem {
  announce_id: number
  party1: string
  party2: string
  reason: string
  bltntypename: string
  content: string
  courtcode: string
  province: string
  publishdate: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeAnnouncements = (items: AnnouncementItem[] = []) =>
  items.map((item) => ({
    type: item.bltntypename,
    reason: item.reason,
    court: `${item.province || ''} ${item.courtcode || ''}`.trim(),
    publishDate: item.publishdate ? dayjs(item.publishdate).format('YYYY-MM-DD') : '—',
    plaintiff: item.party1 || '—',
    defendant: item.party2 || '—',
    content: item.content || '—',
  }))

export default function TianyanchaCourtAnnouncement({ data, title, sectionIndex }: Props) {
  let jsonData: any = {}
  try {
    jsonData = JSON.parse(data.tianyancha_courtAnnouncement ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const announcements = normalizeAnnouncements(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          法院公告
        </Text>
        <Stack gap="sm" className="mt-3">
          {announcements.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无法院公告信息
            </Text>
          ) : (
            announcements.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.type}-${index}`}
                number={index + 1}
                recordType="公告"
                fields={[
                  { label: '公告类型', value: item.type || '—' },
                  { label: '案由', value: item.reason || '—' },
                  { label: '审理法院', value: item.court || '—' },
                  { label: '发布日期', value: item.publishDate },
                  { label: '原告', value: item.plaintiff },
                  { label: '被告', value: item.defendant },
                  { label: '公告内容', value: item.content, span: 2 },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
